import { compose } from 'recompose'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { fetchStoreLocatorSuccess, updateStoreLocatorSuccess } from './actions'
import { selectStoreLocator } from './selectors'

export default () => compose(
  connect(
    (state) => ({
      storeLocator: selectStoreLocator(state),
    }),
    (dispatch) => bindActionCreators(
      { fetchStoreLocatorSuccess, updateStoreLocatorSuccess },
      dispatch,
    ),
  ),
)




// WEBPACK FOOTER //
// ./src/store/storeLocator/withStoreLocator.js